import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import { MAX_ROWS_PER_PAGE } from "src/app/constants/pagination";
import { ChangeDetectorRef, Component, EventEmitter, Inject, Injector, Input, isDevMode, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { BehaviorSubject, catchError, concatMap, debounceTime, exhaustMap, from, Observable, of, ReplaySubject, scan, startWith, Subject, switchMap, tap } from 'rxjs';
import { takeWhileInclusive } from 'rxjs-take-while-inclusive';
import { CommonFile } from 'src/app/models/file';
import { EmptyKeyValue, KeyValue } from 'src/app/models/key-value';
import { MasterCommon } from 'src/app/models/masters/master-common';
import { Vehicle } from 'src/app/models/vehicles/vehicle';
import { ListComponent } from 'src/app/pages/apps/table/list/list.component';
import { ITableParams } from 'src/app/pages/apps/table/models/table-params';
import { DocumentService } from 'src/app/services/api/document.service';
import { MasterService } from 'src/app/services/api/masters.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { documentsTypes, documentTypes } from './types-factory/document-types';
import { Document } from '../../../../../models/documents/document';
import { IFilters } from 'src/app/interfaces/ifilters';
import { ExpedientFilters } from 'src/app/models/expedients/expedient-filters';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/utils/storage.service';
import { CommonService } from 'src/app/services/api/common.service';
import { SaleCreateUpdateComponent } from '../../../expedients/sales/sale-create-update/sale-create-update.component';
import { TransferData } from 'src/app/models/contacts/transfer-data';
import { PurchaseCreateUpdateComponent } from '../../../expedients/purchases/purchase-create-update/purchase-create-update.component';
import { Purchase } from 'src/app/models/expedients/purchase';
import { SendMailComponent } from './send-mail/send-mail.component';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { ImportCostsDialogComponent } from 'src/app/pages/apps/common-dialogs/import-costs-dialog/import-costs-dialog.component';
import { CommonItemList } from 'src/app/models/common-item';
import { Cost } from 'src/app/models/expedients/cost';
import { CommonFilter } from 'src/app/models/masters/common-filter';

/**
 * P10 (Fase 2.26) — Mapeo categoría documental (document_category_id) → tipo de coste de
 * vehículo (vehicle_cost_type_id). Al subir un documento de Expediente de una de estas
 * categorías se abre, ANTES de registrar, un modal de importes por bastidor y, al confirmar,
 * se registra el documento y luego se crea/sobreescribe un coste del tipo mapeado por vehículo.
 * El importe va SIEMPRE al expediente de COMPRA de cada vehículo
 * (vehicles.purchase_administrative_file_id), independientemente de si el documento se sube a un
 * expediente de compra o de venta.
 */
const DOC_CATEGORY_TO_COST_TYPE: Map<number, number> = new Map<number, number>([
  [144, 6],  // FACTURA EUROCOC  -> COC
  [165, 5],  // FACTURA TUV      -> DHL
  [107, 11], // FACTURA GESTORÍA -> Gestoría
  [85, 12],  // BROKER - FACTURA -> Broker compra
  [28, 7],   // FACTURA DAÑOS (Proveedor)  -> Daños proveedor
  [82, 8],   // FACTURA DAÑOS (Transporte) -> Daños transporte
  [44, 10],  // FACTURA CAMPA    -> Campa
  [31, 13],  // BROKER FACTURA (Cliente)   -> Broker venta
  [11, 9]    // FACTURA DAÑOS (Cliente)    -> Daños cliente
]);


@Component({
  selector: 'vex-document-create-update',
  templateUrl: './document-create-update.component.html',
  styleUrls: ['./document-create-update.component.scss']
})
export class DocumentCreateUpdateComponent implements OnInit {

  filteredOptions: Observable<KeyValue[]>;
  @Output() Change: EventEmitter<Array<Vehicle>> = new EventEmitter<Array<Vehicle>>();

  _vehicles: Array<Vehicle>;
  expdedient: Array<Purchase>;

  @Input()
  set vehicles(val: Array<Vehicle>) {
    this.Change.emit(val || []);
    this._vehicles = val || [];
  }
  get vehicles() {
    //this.tableData = this.params?.list?.tableData;
    return this._vehicles;
  }

  saleType: string = 'Expediente de venta';

  public files: any[] = null;
  panelOpenState = false;

  file: CommonFile | null;

  public service: any;

  requiredReference: boolean = false;
  requiredType: boolean = false;

  params: ITableParams<Vehicle, Vehicle>;

  //vehicles: Vehicle[] = [];
  expedient: string = '';

  documentType: string = null;
  reference: KeyValue;

  form: FormGroup;
  mode: 'create' | 'update' = 'create';

  docTypes: Array<KeyValue>;
  progress: boolean;

  documentCategoryId: number;
  sale: Purchase;

  filters: IFilters;
  expedientFilters: ExpedientFilters = new ExpedientFilters();

  expFilters: ExpedientFilters = new ExpedientFilters();

  next$ = new Subject();
  startSearch = new BehaviorSubject<any>('');
  startSearch$ = this.startSearch.asObservable();

  officeId: number;
  signed: boolean = false;
  /** EEC-045: hay una petición de firmado en vuelo. */
  signing: boolean = false;
  /** EEC-113: hay un alta en vuelo; bloquea «Nuevo Documento» para que un doble clic no registre el documento dos veces. */
  saving: boolean = false;
  /** EEC-078: el documento tiene histórico detrás y no admite cambio de categoría. */
  hasHistory: boolean = false;

  pageSize = 10;
  pageIndex = 0;
  order = "desc";
  orderType = "";

  getEntities(typeId: number, page: number): Observable<any[]> {
    if (typeId) {
      const take = 6;
      //const skip = page > 0 ? (page - 1) * take : 0;
      const injectable = documentTypes.get(typeId);
      // Inject service
      this.service = this.injector.get(injectable);
      this.service.getFilters().subscribe((filters) => {
        this.filters = filters;
      })
      if (this.filters) {
        this.filters.pageNumber = page;
        this.filters.rowsPerPage = 6;
        this.filters.order = "asc";
        this.filters.orderBy = "name";
        this.filters.officeId = this.officeId;
        this.filters.name = this.form.value.referenceName.trim();
        return this.masterService.getAllFiltered(documentsTypes.get(typeId), this.filters);
      }
    }
    return of([]);
  }

  async loadData(service, filters) {
    this.masterService.getAllFiltered(service, filters).subscribe(items => {
      return items;
    });

  }
  onScroll() {
    this.next$.next('');
  }

  onPanelOpen(weight: any) {

    // this.startSearch.next(weight.controls['weight'].value);
    this.startSearch.next('');
  }

  categoryTypes: Array<KeyValue>;
  categories: Array<any>;
  filteredCategories: Array<any>;

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
    private dialog: MatDialog,
    private router: Router,
    private dialogRef: MatDialogRef<DocumentCreateUpdateComponent>,
    private fb: FormBuilder,
    private injector: Injector,
    private alert: ToastService,
    private documentService: DocumentService,
    private commonService: CommonService<Purchase, ExpedientFilters>,
    private masterService: MasterService<MasterCommon>,
    public scroll: ScrollDispatcher,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService) {
  }



  ngOnInit() {
    (async () => {
      this.categoryTypes = await this.masterService.get("documentCategoryTypes") as unknown as Array<KeyValue>;
      this.categories = await this.masterService.get("documentCategory") as unknown as Array<any>;
      this.docTypes = await this.masterService.get("documentTypes") as unknown as Array<KeyValue>;

      this.refreshCategories();

    })();
    if (this.defaults.values) {
      this.progress = false;
      this.mode = 'update';
      this.files = [];
      this.downloadFile(this.defaults.values);
    } else {
      this.progress = true;
      this.defaults.values = {} as Document;
    }

    this.signed = this.defaults.values.signed ? this.defaults.values.signed : false;
    this.hasHistory = this.defaults.values.hasHistory ? true : false;

    this.documentType = this.defaults?.type || this.defaults?.values.documentType?.name;
    this.documentCategoryId = this.defaults?.documentCategoryId;
    this.reference = this.defaults?.reference;
    this.vehicles = this.defaults?.values.vehicles;
    if (!this.documentType)
      this.requiredType = true;

    this.storageService.getItem("origin").subscribe(origin => {
      this.officeId = origin;
    });

    this.form = this.fb.group({
      date: [this.defaults.values.date || ''],
      name: this.defaults.values.name || '',
      documentType: [this.defaults.values.documentType || ''],
      description: this.defaults.values.description || '',
      reference: this.defaults.values.reference || '',
      referenceName: this.defaults.values.referenceName || '',
      documentCategory: [this.defaults.values.documentCategory || ''],
      documentCategoryTypes: [this.defaults.values.documentCategoryTypes || ''],
      estimatedDate: [this.defaults.values.estimatedDate || this.getDefaultEstimatedDate()],
      remarks: this.defaults.values.remarks || '',
      isVisible: this.defaults.values.isVisible || null,
      files: [this.files, Validators.required],
      n_cmr: this.defaults.values.n_cmr || '',
    });

    this.showEstimatedDate(this.form.get('documentCategory')?.value);

    if (!this.defaults?.type) {
      this.loadTypeOptions();
      this.loadExpedient();
    }
    else if (this.defaults?.type == 'Expediente') {
      this.expedientFilters.administrativeFileId = this.defaults.reference.id;
      this.expedientFilters.pageNumber = 0;
      this.expedientFilters.rowsPerPage = 5;
      this.expedientFilters.order = "asc";
      this.expedientFilters.orderBy = "name";
      this.loadParams();
    }
  }

  getDefaultEstimatedDate(): Date {
    const date = new Date();
    date.setDate(date.getDate() + 15);
    return date;
  }

  loadExpedient() {
    if (this.documentType == 'Expediente') {
      this.filteredOptions.subscribe(x => {
        const items = x.filter(z => z.name == this.form.value.referenceName.trim());
        this.expedientFilters.administrativeFileId = items[0]?.id;
        this.expedientFilters.pageNumber = 0;
        this.expedientFilters.rowsPerPage = 5;
        this.expedientFilters.order = "asc";
        this.expedientFilters.orderBy = "name";

        this.loadParams();
      }
      );
    }
  }

  downloadFile(doc: Document) {
    this.documentService.getDocument(doc).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No se ha podido descargar el documento " + doc.name);
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            /* var pdfResult = response.base64;
            var file = this.base64toBlob(pdfResult, doc.mimeType);
            var fileURL = URL.createObjectURL(file); */

            const base64 = atob(response.base64);

            // Convertir Base64 a contenido binario
            const arrayBuffer = new Uint8Array(base64.length);
            for (let i = 0; i < base64.length; i++) {
                arrayBuffer[i] = base64.charCodeAt(i);
            }

            // Crear un Blob con el contenido decodificado
            const fileBlob = new Blob([arrayBuffer], { type: response.mimeType });

            // Crear un objeto File y almacenarlo en la lista
            const file = new File([fileBlob], doc.originalName, { type: response.mimeType });
            this.files.push(file);


            // Actualizar el formulario con el archivo descargado
            this.form.controls['files'].patchValue(this.files);

          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No se ha podido descargar el documento " + doc.originalName);
        }
    });
  }

  loadParams() {
    this.params = {
      isMenu: false,
      title: 'Vehículos',
      element: "Vehículo",
      titleProperty: 'name',
      hasImage: false,
      tableData: this._vehicles || [],
      disabledMode: this.reference ? false : true,
      columns: [
        { label: 'Casilla de selección', property: 'checkbox', type: 'checkbox', visible: true },
        { label: 'Modelo', property: 'name', type: 'text', visible: true },
        { label: 'Matrícula', property: 'plate', type: 'text', visible: true },
        { label: 'Bastidor', property: 'vin', type: 'text', visible: true },

      ],
      list: {
        isMenu: false,
        element: "Vehículo",
        title: 'Vehículos',
        titleProperty: 'name',
        service: "administrative-files/vehicles/maestra",
        hasImage: false,
        filters: this.expedientFilters,
        paginatedOnBack: true,
        columns: [
          { label: 'Casilla de selección', property: 'checkbox', type: 'checkbox', visible: true },
          { label: 'Modelo', property: 'name', type: 'text', visible: true },
          { label: 'Matrícula', property: 'plate', type: 'text', visible: true },
          { label: 'Bastidor', property: 'vin', type: 'text', visible: true },

        ],
        //tableData: carsTableData.map(car => new Car(car)),
      }
    }
  }
  checkType() {
    if ((this.form?.value?.documentType?.id > 1 && this.form?.value?.documentType?.id < 5) || this.form?.value?.documentType?.id == 6 || this.form?.value?.documentType?.id == 7)
      return true;

    return false;
  }

  loadTypeOptions() {
    this.filteredOptions = this.startSearch$.pipe(
      startWith(''),
      debounceTime(200),
      switchMap(filter => {
        //Note: Reset the page with every new seach text
        let currentPage = 1;
        return this.next$.pipe(
          startWith(currentPage),
          exhaustMap(_ => this.getEntities(this.form?.value?.documentType?.id, currentPage)),
          tap(() => currentPage++),
          takeWhileInclusive((p: any) => p.length > 0),
          scan(
            (allItems: any, newItems: any) =>
              allItems.concat(newItems),
            []
          )
        );
      })
    );
  }
  SearchWeightuggestions(val: any) {

    //const d = this.getEntities(String(val),1);
    const d = this.getEntities(this.form?.value?.documentType?.id, 1);
    this.startSearch.next(val.trim());
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.scroll.scrolled().subscribe((data: CdkScrollable) => {
      console.log(data);
      //make an HTTP call when it reaches to the end, to add some more data
    });
  }

  compareCategoryObjects(object1: any, object2: any) {
    return object1 && object2 && object1.id == object2.id;
  }

  displayFn(option) {
    if (option && option.name) {
      return option.name.toLowerCase();
    } else {
      return option
    }
  }

  save() {
    if (this.mode === 'create') {
      // EEC-113: se marca aquí, antes del diálogo de costes; se libera si se cancela o si el API falla o rechaza.
      if (this.saving) return;
      this.saving = true;
      // P10: documento de Expediente de categoría mapeada -> interceptar para asignar costes
      const categoryId = Number(this.form.value.documentCategory?.id ?? this.documentCategoryId);
      const adminFileId = this.reference?.id || this.form.value.referenceId;
      if (this.documentType == 'Expediente'
          && !isNaN(categoryId)
          && DOC_CATEGORY_TO_COST_TYPE.has(categoryId)
          && this.vehicles?.length > 0
          && adminFileId) {
        this.openImportCostsModal(DOC_CATEGORY_TO_COST_TYPE.get(categoryId), adminFileId);
      } else {
        this.createDocument();
      }
    } else if (this.mode === 'update') {
      this.updateDocument();
    }
  }

  /**
   * P10: recupera (GET) los vehículos del expediente con sus costes y su expediente de compra, abre
   * el modal de importes prefijado con el coste de COMPRA activo del tipo mapeado por vehículo y, al
   * confirmar, registra el documento y después crea/sobreescribe los costes en el expediente de
   * compra de cada vehículo. Al cancelar no se registra nada.
   */
  openImportCostsModal(mappedTypeId: number, adminFileId: number) {
    this.fetchExistingCosts(adminFileId, mappedTypeId).subscribe(existingByVehicle => {
      const rows = (this.vehicles || []).map(v => {
        const existing: any = existingByVehicle.get(v.id);
        return {
          vehicleId: v.id,
          vin: v.vin || v.name || ('#' + v.id),
          existingCostId: existing?.cost?.id ?? null,
          importe: existing?.cost ? this.getCostAmount(existing.cost) : null
        };
      });

      this.dialog.open(ImportCostsDialogComponent, {
        disableClose: true,
        data: { vehicles: rows, title: 'Costes de vehículos' }
      }).afterClosed().subscribe((result: { confirm: boolean, items: Array<any> }) => {
        if (result?.confirm) {
          // Registrar el documento y, después, los costes por vehículo (en ese orden)
          this.createDocument((documents: Array<Document>) =>
            this.registerVehicleCosts(mappedTypeId, result.items, existingByVehicle, documents));
        } else {
          // Cancelar/descartar: no se registra nada, el usuario permanece en el modal de documento.
          this.saving = false;
        }
      });
    });
  }

  /**
   * GET de los vehículos-con-costes del expediente (endpoint que usa la tabla de vehículos).
   * Devuelve un mapa vehicleId -> { purchaseAdminFileId, cost } donde `cost` es el coste de COMPRA
   * (order_type 2) activo del tipo mapeado (o null) y `purchaseAdminFileId` es el expediente de
   * compra del vehículo (destino de los importes).
   */
  fetchExistingCosts(adminFileId: number, mappedTypeId: number): Observable<Map<number, any>> {
    const result = new ReplaySubject<Map<number, any>>(1);
    const map = new Map<number, any>();

    const filters: any = new CommonFilter(adminFileId);
    filters.rowsPerPage = MAX_ROWS_PER_PAGE;
    filters.pageNumber = 1;
    filters.orderBy = 'name';
    filters.order = 'asc';

    // Coste de COMPRA (order_type 2) activo del tipo mapeado.
    const matchPurchase = (costs: Array<any>) =>
      (costs || []).find(c => c.isActive && c.orderType?.id == 2 && c.vehicleCostType?.id == mappedTypeId);

    this.commonService.getAll('administrative-files/vehicles', filters).subscribe({
      next: (response: any) => {
        if (response?.isSuccessful && response.data) {
          response.data.forEach((v: any) => {
            map.set(v.id ?? v.vehicleId, {
              purchaseAdminFileId: v.purchaseAdministrativeFileId ?? null,
              cost: matchPurchase(v.costs) ?? null
            });
          });
        }
        result.next(map);
      },
      error: () => result.next(map)
    });

    return result;
  }

  /** Importe a prefijar desde el coste de compra existente. */
  getCostAmount(cost: any): number {
    return Number(cost?.cost ?? 0) || Number(cost?.salePrice ?? 0) || 0;
  }

  /**
   * P10: por cada vehículo con importe, sobreescribe (update) el coste de compra existente del tipo
   * mapeado o crea uno nuevo "simple" SIEMPRE en el expediente de COMPRA del vehículo (no en el
   * expediente donde se sube el documento). El backend estampa el order_type del expediente de
   * compra y valida que sea el del vehículo. Los vehículos sin expediente de compra se omiten con aviso.
   * Las altas se agrupan por expediente de compra (una petición de lote por grupo) y todas las
   * peticiones se encadenan con concatMap: nunca hay dos en vuelo a la vez.
   */
  registerVehicleCosts(mappedTypeId: number, items: Array<any>,
    existingByVehicle: Map<number, any>, documents: Array<Document>) {

    const validItems = (items || []).filter(it =>
      it.importe !== null && it.importe !== undefined && it.importe !== '' && !isNaN(Number(it.importe)));

    // Cada importe va al expediente de compra del vehículo; sin él no se puede registrar.
    const skipped: Array<string> = [];
    const registrableItems = validItems.filter(it => {
      const purchaseAdminFileId = existingByVehicle.get(it.vehicleId)?.purchaseAdminFileId;
      if (!purchaseAdminFileId) {
        const v: any = (this.vehicles || []).find(x => x.id == it.vehicleId);
        skipped.push(v?.vin || ('#' + it.vehicleId));
      }
      return !!purchaseAdminFileId;
    });

    if (skipped.length > 0) {
      this.alert.info('Sin expediente de compra, no se asignaron costes a: ' + skipped.join(', '));
    }

    if (registrableItems.length === 0) {
      this.dialogRef.close(documents);
      return;
    }

    // Las ALTAS se agrupan por expediente de compra y viajan en una única petición por grupo
    // (endpoint de lote), no una petición por vehículo. El backend recorre el lote dentro de un
    // solo proceso, de modo que la generación del código de proforma (Config -> value + 1, sin
    // bloqueo) no puede colisionar consigo misma. Con una petición por vehículo en paralelo, varias
    // leían el mismo contador, el índice único rechazaba las repetidas y el coste ya insertado se
    // quedaba sin proforma -> luego reventaba el listado de expedientes.
    // Las ACTUALIZACIONES no generan proforma, así que no participan de esa carrera.
    const altasPorExpediente = new Map<number, Array<any>>();
    const actualizaciones: Array<CommonItemList<Cost>> = [];

    registrableItems.forEach(it => {
      const purchaseAdminFileId = existingByVehicle.get(it.vehicleId).purchaseAdminFileId;
      const costPayload = this.buildCostPayload(it, mappedTypeId, existingByVehicle);

      if (it.costId) {
        const item = new CommonItemList<Cost>(purchaseAdminFileId, [costPayload]);
        item.vehicleId = it.vehicleId;
        actualizaciones.push(item);
      } else {
        const grupo = altasPorExpediente.get(purchaseAdminFileId) || [];
        grupo.push({ vehicleId: it.vehicleId, costs: [costPayload] });
        altasPorExpediente.set(purchaseAdminFileId, grupo);
      }
    });

    const requests: Array<Observable<any>> = [];

    // Un grupo = un expediente de compra. El endpoint de lote valida que todos los vehículos
    // del lote pertenezcan al expediente enviado, y por eso la clave de agrupación es esa.
    altasPorExpediente.forEach((vehiculos, purchaseAdminFileId) => {
      requests.push(this.commonService.addRange(
        'administrative-files/vehicle-costs/list',
        new CommonItemList<any>(purchaseAdminFileId, vehiculos)));
    });

    actualizaciones.forEach(item =>
      requests.push(this.commonService.updateRange('administrative-files/vehicle-costs', item)));

    // concatMap encadena: no se suscribe a la siguiente hasta que la anterior completa, así que
    // dos peticiones nunca se solapan (un forEach con subscribe dentro las lanzaba todas a la vez).
    from(requests).pipe(
      concatMap(request$ => request$.pipe(catchError(() => of(null))))
    ).subscribe({
      next: (response: any) => {
        if (response && response.isSuccessful === false) {
          this.alert.info(response.message);
        }
      },
      complete: () => this.dialogRef.close(documents)
    });
  }

  /** Construye el payload de coste (overwrite preservando proforma/IVA del existente, o nuevo simple). */
  private buildCostPayload(it: any, mappedTypeId: number, existingByVehicle: Map<number, any>): any {
    const importe = Number(it.importe);
    if (it.costId) {
      const existing: any = existingByVehicle.get(it.vehicleId)?.cost || {};
      return {
        id: it.costId,
        cost: importe,
        salePrice: importe,
        vehicleCostType: existing.vehicleCostType || { id: mappedTypeId },
        orderType: existing.orderType,
        costType: existing.orderType,
        proformaInvoice: (existing.proformaInvoice && existing.proformaInvoice.id) ? existing.proformaInvoice : new EmptyKeyValue(),
        vatType: (existing.vatType && existing.vatType.id) ? existing.vatType : new EmptyKeyValue(),
        entity: new EmptyKeyValue(),
        chargedUser: existing.chargedUser || null,
        remarks: existing.remarks || '',
        status: ''
      };
    }
    return {
      cost: importe,
      salePrice: importe,
      vehicleCostType: { id: mappedTypeId },
      // El backend (adminFilesVehiclesCostRegister) lee costType['id'] de forma incondicional;
      // sin esta clave PHP 8.1 lanza "Undefined array key" -> 500 y el coste nuevo no se crea.
      // EmptyKeyValue (id null) basta: ninguno de los tipos mapeados es 3, así que la rama
      // chargedUser/remarks no aplica, y el backend deriva order_type_id del expediente.
      costType: new EmptyKeyValue(),
      entity: new EmptyKeyValue(),
      vatType: new EmptyKeyValue(),
      proformaInvoice: new EmptyKeyValue(),
      isActive: true,
      isVisible: true,
      isCorrection: false,
      status: '',
      date: new Date()
    };
  }

  getReferenceId(referenceName) {
    this.filteredOptions.subscribe(x => {
      const items = x.filter(z => z.name == referenceName);
      return items[0].id;
    });
  }

  createDocument(afterRegister?: (documents: Array<Document>) => void) {

    const document = this.form.value;
    document.active = true;
    document.createdAt = new Date();

    document.referenceName = this.reference?.name || this.form.value.referenceName;
    document.referenceId = this.reference?.id || this.form.value.referenceId;


    document.url = this.form.value.url || '';
    document.vehicles = this.vehicles || [];
    if (!document.date) {
      document.date = new Date();
    }
    if (this.documentType) {
      document.documentType = this.docTypes.filter(d => d.name === this.documentType)[0];
    }

    const name = document.name;
    let documents: Array<Document> = [];
    if (this.filteredOptions && this.checkType()) {
      this.filteredOptions.subscribe(x => {
        const items = x.filter(z => z.name == this.form.value.referenceName);
        document.referenceId = this.reference?.id || items[0]?.id || null;

        this.files.forEach(x => {
          this.convertFile(x).subscribe({
            // EEC-113 adversarial: si el fichero ya no se puede leer, el modal no se queda bloqueado en «Subiendo…».
            error: () => {
              this.saving = false;
              this.alert.error("No se ha podido leer el fichero " + x.name + ". Vuelve a seleccionarlo");
            },
            next: base64 => {
            document.file = new CommonFile(x.name, x.type, base64);
            if (this.files.indexOf(x) > 0)
              document.name = name + ' (' + Number(1 + this.files.indexOf(x)) + ')';
            this.documentService.createDocument(document).subscribe({
                next:
                  response => {
                    if (!response) {
                      this.saving = false;
                      this.alert.error("No ha sido posible actualizar el documento");
                    }
                    else if (!response.isSuccessful) {
                      this.saving = false;
                      this.alert.info(response.message);
                    }
                    else {
                      documents.push(document);

                      // Si es cat CMR abrir modal de correo
                      if (response.data[0].documentCategory.name == 'CMR') {
                        this.dialog.open(SendMailComponent,
                          {
                            data: response.data[0]
                          })
                      }

                      if (documents.length == this.files.length) {
                        this.saving = false;
                        if (afterRegister)
                          afterRegister(documents);
                        else
                          this.dialogRef.close(documents);
                      }
                    }
                  },
                error:
                  (e) => {
                    this.saving = false;
                    if (e.status == '401') {
                      this.router.navigate(['/login']);
                      this.alert.info("Sesión expirada")
                      return;
                    }
                    if (isDevMode)
                      this.alert.error(e.message)
                    else
                      this.alert.error("No ha sido posible actualizar el documento");
                  }
              })
          }});
        });

      })
    }
    else {
      document.referenceId = this.reference?.id || null;
      this.files.forEach(x => {
        this.convertFile(x).subscribe({
          error: () => {
            this.saving = false;
            this.alert.error("No se ha podido leer el fichero " + x.name + ". Vuelve a seleccionarlo");
          },
          next: base64 => {
          document.file = new CommonFile(x.name, x.type, base64);
          if (this.files.indexOf(x) > 0)
            document.name = name + ' (' + (Number(this.files.indexOf(x))) + ')';
          this.documentService.createDocument(document).subscribe({
            next: (response) => {
              // EEC-113: el API rechaza con mensaje el duplicado de un alta reciente; antes esta rama no lo miraba.
              if (!response) {
                this.saving = false;
                this.alert.error("No ha sido posible actualizar el documento");
                return;
              }
              if (!response.isSuccessful) {
                this.saving = false;
                this.alert.info(response.message);
                return;
              }
              documents.push(document);

              // Si es cat CMR abrir modal de correo
              if (response.data[0].documentCategory.name == 'CMR') {
                this.dialog.open(SendMailComponent,
                  {
                    data: response.data[0]
                  })
              }

              if (documents.length == this.files.length) {
                this.saving = false;
                if (afterRegister)
                  afterRegister(documents);
                else
                  this.dialogRef.close(documents);
              }
            },
            error: (e) => {
              this.saving = false;
              if (e.status == '401') {
                this.router.navigate(['/login']);
                this.alert.info("Sesión expirada")
                return;
              }
              if (isDevMode)
                this.alert.error(e.message)
              else
                this.alert.error("No ha sido posible actualizar el documento");
            }
          });

        }});
      });
    }

  }

  updateDocument() {
    const document = this.form.value;
    document.id = this.defaults.values.id;
    /*  document.referenceId = this.form.value.reference.id; */
    document.referenceName = this.reference?.name || this.form.value.referenceName || '';
    document.referenceId = this.reference?.id || this.form.value.referenceId;

    if (this.documentType) {
      document.documentType = this.docTypes.filter(d => d.name === this.documentType)[0];
    }

    document.url = this.defaults.values.url || '';
    document.createdAt = this.defaults.values.createdAt;
    document.vehicles = this.vehicles || [];
    document.originalName = this.defaults.values.originalName;
    document.storageName = this.defaults.values.storageName;

    if (this.filteredOptions && this.checkType()) {
      this.filteredOptions.subscribe(x => {
        this.convertFile(this.files[0]).subscribe(base64 => {
          document.file = new CommonFile(this.files[0].name, this.files[0].type, base64);
          const items = x.filter(z => z.name == this.form.value.referenceName);
          document.referenceId = this.reference?.id || items[0]?.id || null;
          this.modifyDocumento(document);
        });
      })
    }
    else {
      document.referenceId = this.reference?.id || null;
      this.convertFile(this.files[0]).subscribe(base64 => {
        document.file = new CommonFile(this.files[0].name, this.files[0].type, base64);
        this.modifyDocumento(document);
      });
    }

  }

  refreshCategories(event?) {
    if (event) {
      this.filteredCategories = this.categories.filter(item => item.documentCategoryType.id == event.id);
    } else {
      this.filteredCategories = this.categories.filter(item => item.documentCategoryType.id == this.form.get('documentCategoryTypes')?.value.id);
    }
  }

  isCreateMode() {
    return this.mode === 'create';
  }

  isUpdateMode() {
    return this.mode === 'update';
  }

  onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onSelectAll(items: any) {
    console.log('onSelectAll', items);
  }

  onValueChange(file: File[]) {
    console.log("File changed!");
  }
  selectedRole(event: MatSelectChange) {
    this.defaults.values.role = event.source.triggerValue;
  }

  changeType(type: any) {
    const service = documentsTypes.get(type.id);
    //this.getEntities(service,1);
    this.documentType = type.name;
    //this.reference = null;
    this.loadTypeOptions();
    this.expedient = '';
    this.vehicles = [];
    this.form.get('referenceName').setValue("");
    this.params = null;
    //this.items = expedientsTableData.map(({ id: id, internalId: value }) => ({ id, value }));
    //this.cities = [];
  }

  showEstimatedDate(type: any) {
    if (type.name == 'CMR' || type.name == 'CMR ORIGINAL') {
      this.form.get('estimatedDate').enable();
    } else {
      this.form.get('estimatedDate').disable();
    }
  }

  loadCars(type) {
    if (type === 'Expediente') {
      this.dialog.open(ListComponent,
        {
          data: this.params.list
        }).afterClosed().subscribe((vehicles: Vehicle[]) => {
          if (vehicles) {
            this.vehicles = vehicles;
          }
        });
    }

  }

  addDocument(doc: Document) {
    //doc.file = this.file;
    this.documentService.createDocument(doc).subscribe(
      {
        next:
          response => {
            if (!response) {
              this.alert.error("No ha sido posible dar de alta el documento");
            }
            else if (!response.isSuccessful) {
              this.alert.info(response.message);
            }
            else {
              doc.id = response.data[0].id;
              doc.url = response.data[0].url;
              doc.originalName = response.data[0].originalName;
              doc.storageName = response.data[0].storageName;
              doc.mimeType = response.data[0].mimeType;

            }
          },
        error:
          (e) => {
            if (e.status == '401') {
              this.router.navigate(['/login']);
              this.alert.info("Sesión expirada")
              return;
            }
            if (isDevMode)
              this.alert.error(e.message)
            else
              this.alert.error("No ha sido posible dar de alta el documento");
          }
      });

  }

  modifyDocumento(doc: Document) {
    //doc.file = this.file || null;
    this.documentService.updateDocument(doc).subscribe(
      {
        next:
          response => {
            if (!response) {
              this.alert.error("No ha sido posible actualizar el documento");
            }
            else if (!response.isSuccessful) {
              this.alert.info(response.message);
            }
            else {
              doc.url = response.data[0].url;
              doc.mimeType = response.data[0].mimeType;
              this.dialogRef.close(doc);
            }
          },
        error:
          (e) => {
            if (e.status == '401') {
              this.router.navigate(['/login']);
              this.alert.info("Sesión expirada")
              return;
            }
            if (isDevMode)
              this.alert.error(e.message)
            else
              this.alert.error("No ha sido posible actualizar el documento");
          }
      });

  }



  handleFileInput(event: Event) {
    let file: File = event.target['files'][0];
    this.convertFile(file).subscribe(base64 => {

      this.file = new CommonFile(file.name, file.type, base64);
    });

  }
  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    // EEC-045: si el fichero ya no se puede leer (borrado, unidad desconectada,
    // marcador de nube sin descargar) el observable falla en vez de callar.
    reader.onerror = () => result.error(reader.error);
    return result;
  }

  setExpedient(event) {
    this.vehicles = [];
    this.params = null;
    //this.expedient = event.value;
    this.loadExpedient();
  }


  openFullAggregatorsList(event: Event, trigger: MatAutocompleteTrigger) {
    event.stopPropagation();
    trigger.openPanel();
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(files) {
    if (this.isUpdateMode())
      if (files.length > 1) {
        this.alert.info("Solo puede subir un documento");
        return;
      }

    this.prepareFilesList(files);
  }


  openFile(file: File) {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }


  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
    this.form.controls['files'].patchValue(this.files);
    this.progress = true;
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index]?.progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 20);
      }
    }, 100);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    let message: string = '';
    for (const item of files) {
      if (item.size > 31457280) {
        if (!message)
          message = "Solo puede subir documentos de menos de 30MB. Se descartó '" + item.name + "'";
        else
          message = message + ", '" + item.name + "'";
      }
      else {
        if (this.isUpdateMode())
          this.deleteFile(0);
        item.progress = 0;
        if (!this.files)
          this.files = [];
        this.files.push(item);

        this.form.controls['files'].patchValue(this.files);
      }
    }
    this.uploadFilesSimulator(0);
    if (message)
      this.alert.info(message);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  loadFilters() {
    this.expFilters.pageNumber = this.pageIndex + 1;
    this.expFilters.rowsPerPage = this.pageSize;
    this.expFilters.order = this.order;
    this.expFilters.orderBy = this.orderType;
    this.expFilters.id = this.defaults.values.referenceId;
    this.storageService.getItem("origin").subscribe(origin => {
      if (this.expFilters.officeId != origin) {
        this.expFilters.officeId = origin;
        //this.loadData();
      }
    })
    this.expFilters.orderTypeId = 1;

  }

  loadAdminFiles() {

    this.loadFilters();
    this.commonService.getAll('administrative-files', this.expFilters).subscribe({
      next:
        response => {
          if (!response) {
            this.alert.error("No hay expedientes");
          }
          else if (!response.isSuccessful) {
            this.alert.info(response.message);
          }
          else {
            this.sale = response.data[0];
            this.dialog.open(SaleCreateUpdateComponent, {
              data: new TransferData({
                values: this.sale,
                type: this.saleType,
                filters: this.expFilters
              })
            })
          }
        },
      error:
        (e) => {
          if (e.status == '401') {
            this.router.navigate(['/login']);
            this.alert.info("Sesión expirada")
            return;
          }
          if (isDevMode)
            this.alert.error(e.message)
          else
            this.alert.error("No ha sido posible recuperar la lista de expedientes");
        }
    });
  }

/*   getFirst4Characters(name: string): string {
    return name.slice(0, 4);
  } */

  getFirstXCharacters(name: string, ext: number): string {
    return name.slice(0, ext);
  }

  sign() {

    // EEC-045: una sola petición en vuelo. El PDF viaja en base64 y tarda
    // segundos; el segundo clic llegaba con el histórico ya movido y dejaba
    // un documento «CRV» vacío en el expediente.
    if (this.signing) return;
    this.signing = true;

    let item = this.form.value;
    item.id = this.defaults.values.id;

    this.convertFile(this.files[0]).subscribe({
      error: () => {
        // Sin esto el botón se quedaba en «Adjuntando…» sin petición en vuelo.
        this.signing = false;
        this.alert.error("No se ha podido leer el fichero. Vuelve a seleccionarlo");
      },
      next: base64 => {
      item.file = new CommonFile(this.files[0].name, this.files[0].type, base64);

      this.commonService.update('documents/crv', item).subscribe({
        next:
          response => {
            this.signing = false;
            if (!response) {
              this.alert.error("No ha sido posible actualizar el documento");
            }
            else if (!response.isSuccessful) {
              this.alert.info(response.message);
            }
            else {
              this.alert.info("CRV firmado adjuntado con éxito");
              this.dialogRef.close();
            }
          },
        error:
          (e) => {
            this.signing = false;
            if (e.status == '401') {
              this.router.navigate(['/login']);
              this.alert.info("Sesión expirada")
              return;
            }
            if (isDevMode)
              this.alert.error(e.message)
            else
              this.alert.error("No ha sido posible actualizar el documento");
          }
      });

      }
    });
  }
}


